import { gql, TypedDocumentNode } from '@apollo/client'
import { getApolloClient } from '@vivaldis/common'
import { SuMissingSafetyAnswerReminderInput } from '../../../../../typings/__generated__'
import type {
  SuMissingSafetyAnswerReminderMutation,
  SuMissingSafetyAnswerReminderMutationVariables
} from './__generated__/SuMissingSafetyAnswerReminderMutation'

const mutation: TypedDocumentNode<
  SuMissingSafetyAnswerReminderMutation,
  SuMissingSafetyAnswerReminderMutationVariables
> = gql`
  mutation SuMissingSafetyAnswerReminderMutation(
    $input: SuMissingSafetyAnswerReminderInput!
  ) {
    suMissingSafetyAnswerReminder(input: $input) {
      status
    }
  }
`

export const suMissingSafetyAnswerReminderMutation = (
  input: SuMissingSafetyAnswerReminderInput
) => {
  const apolloClient = getApolloClient()
  return apolloClient.mutate({
    mutation: mutation,
    variables: {
      input: input
    }
  })
}
